/** @jsx jsx */
import React from 'react'
import { jsx, useThemeUI } from 'theme-ui'
import { ConditionalWrapper } from '../../utils/conditional-wrapper'
import ImgixImage from '../helpers/ev-imgix/connected'
import getSizes from '../helpers/ev-imgix/get-sizes'
import { Type } from '@uswitch/spark'
import { isChildOfContainerContext, Link } from '../helpers/react'

const getLinkProps = (link) =>
  link.includes('http') ? { rel: 'nofollow noreferrer noopener', target: '_blank' } : {}

const ImageModule = ({
  image = {},
  options = {},
  className = '',
  linkHref = '',
  useContainer = false,
  caption = '',
  critical = false,
  ...rest
}) => {
  const { theme = {} } = useThemeUI()
  const widths = options?.width && [].concat(options.width)
  const sizes = widths ? getSizes(widths, theme.breakpoints) : undefined
  const linkProps = getLinkProps(linkHref)

  return (
    <ConditionalWrapper condition={useContainer} wrapper={Container} styles={options.styles}>
      <ConditionalWrapper condition={linkHref} wrapper={Anchor} href={linkHref} {...linkProps}>
        <ImgixImage
          critical={critical}
          className={className}
          imgixParams={options?.imgixParams}
          entity={image}
          width={widths && widths[widths.length - 1]}
          sizes={sizes}
          sx={{
            maxWidth: widths || '100%',
            ...options.styles,
          }}
          {...rest}
        />
        <Type.Body2
          sx={{
            variant: 'modules.imageModule.imageLabel',
          }}
        >
          {caption}
        </Type.Body2>
      </ConditionalWrapper>
    </ConditionalWrapper>
  )
}

const Anchor = ({ children, ...rest }) => <Link {...rest}>{children}</Link>

const Container = ({ children, styles }) => (
  <div sx={{ ...styles, width: '100%' }}>
    <isChildOfContainerContext.Provider value={true}>{children}</isChildOfContainerContext.Provider>
  </div>
)

export default ImageModule
